import React from 'react';
import {Flex} from "../ui";
import CurrencyFormat from 'react-currency-format';
import {Modal} from "../ServiciosMaestros/componentGeneral";
export default function AlertDialog(props) {
  function handleClose() {
    props.closeModal();
  }
  return(
      <Modal open={props.visible} close={handleClose} tipo={"info"}>

          <Flex style={{color: '#8BB5FC'}}
                direction={"colunm"}
                className={"py-3"}
          >
              <h5>
                  <i style={{color: "#40A8E6"}}
                     className={props.icono + " mr-3"}
                  />
                  {props.titulo}
              </h5>
          </Flex>
          <p className={"text-center mb-0  pb-2 mb-2"} style={{color: '#8E8C8C',borderBottom:"1px solid #e4e4e4"}}><b>{props.subtitulo}</b></p>
            <div className={"wc"} style={{maxHeight:"calc(100vh - 230px)",overflow:"hidden auto"}}>
                {
                    props.data.map((item, key) =>
                        <Flex className={'pb-1 wc'} key={key} >
                            <div className={"col-6 text-right"} style={{color: 'black'}}>
                                <small className={"mb-0"}><b>{item.llave}:</b></small>
                            </div>
                            <div className={'col-6 px-2 '}>
                                {item.entidad === 'total' || item.entidad === 'segundoTotal' || item.entidad === 'tercerTotal'?
                                    <CurrencyFormat value={item.valor} displayType={'text'} thousandSeparator={true} prefix={'$'}/>
                                    :<p className={"mb-0"}>{item.valor}</p>}
                            </div>
                        </Flex>
                    )
                }
            </div>

      </Modal>
  );
}
